import React, {useEffect, useState} from 'react';
import {Col, Form, InputNumber, Radio, Row} from "antd";
import {attendanceGps, DEFAULT_RADIUS} from "../constant/key";
import InputDecimal from "../../../../../custom/data-entry/input-number/InputDecimal";
import {t} from "i18next";
export const optionTypeGPS = (t) => { return [
    {
        label: t("tnp.setting.radiusRange"),
        value: 'radius',
    },
    {
        label: t("tnp.setting.boundingBox"),
        value: 'boundingBox',
    }
]};
export const optionBoundingBox = (t) => {return  [
    {
        label: t("tnp.setting.province"),
        value: 'province',
    },
    {
        label: t("tnp.setting.district"),
        value: 'district',
    } ,
    {
        label: t("tnp.setting.communes"),
        value: 'communes',
    }
]};

const Radius = (props) => {

    const type = Form.useWatch(attendanceGps.type, props.form) || "radius"
    const boundingBox = Form.useWatch(attendanceGps.boundingBox, props.form) || "province"
    const watchRadius = Form.useWatch(attendanceGps.radius, props.form) || props.radius

    function mapTextBoundingBox  (boundingBox)  {
      switch (boundingBox) {
          case "communes" :
              return optionBoundingBox(t)[2]?.label;
          case "district" :
              return optionBoundingBox(t)[1]?.label;
          default :
              return optionBoundingBox(t)[0]?.label;
      }
    }

    useEffect(() => {
        props.setRadius(watchRadius)
    }, [watchRadius]);

    return (
        <>
            <Row gutter={12} className={"mt-2"}>

                <Col
                    xxl={{span: 16}}
                    xl={{span: 16}}
                    lg={{span: 16}}>
                    <Form.Item label={<b>{props.label}</b>} name={attendanceGps.type}>
                        <Radio.Group block
                                     options={optionTypeGPS(t)}
                                     defaultValue="radius"
                        />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={12} className={"mt-2"}>
                <Col
                    xxl={{span: 16}}
                    xl={{span: type === "radius" ? 16 : 24}}
                    lg={{span: type === "radius" ? 16 : 24}}>
                    {
                        type === "radius" ?
                            <Form.Item
                                tooltip={t("tnp.setting.radiusToolTip")}
                                initialValue={DEFAULT_RADIUS}
                                label={<b>{t("tnp.setting.valueRadius")}</b>}
                                name={attendanceGps.radius}
                                rules={[{required: props.require}]}>

                                <InputDecimal
                                    form = {props.form}
                                    name={attendanceGps.radius}
                                />

                            </Form.Item>
                            :
                            <>
                                <Form.Item
                                    label={<b>{t("tnp.setting.selectBoundingType")}</b>}
                                    name={attendanceGps.boundingBox}
                                    initialValue={"province"}
                                    tooltip={
                                        <span  dangerouslySetInnerHTML={{
                                            __html:  t("tnp.setting.selectBoundingTypeToolTip",{name : `<span class="font-bold">${mapTextBoundingBox(boundingBox) } </span>` })
                                        }} />
                                    // "Hệ thống sẽ kiểm tra tọa độ chấm công nằm trong " + mapTextBoundingBox(boundingBox)  + " của vị trí chấm công hay không"
                                }
                                >
                                    <Radio.Group block
                                                 options={optionBoundingBox(t)}
                                                 defaultValue="province"
                                    />
                                </Form.Item>
                            </>
                    }
                </Col>
            </Row>
        </>

    );
};


export default Radius;
